import type { App } from 'vue'
// Bun's dev bundle breaks zod's core ↔ util import cycle when zod first loads inside the chat's lazy AG-UI import.
import 'zod'
import { registerComponents } from './components'

export type { ChatPage } from './composables'
export type { CardPart, ChatAttachment, ChatChip, ChatImage, ChatPicture, ChatReferenceCard, ChatView, ShellTurn, ToolPart } from './model'
export { cardStateOf } from './model'

export const createChat = () => ({
  install: (app: App) => registerComponents(app)
})
